// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/inventory_stock_point_split.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { InventoryStockPointSplitItem, ItemType } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.InventoryStockPointSplitRequest
 */
export class InventoryStockPointSplitRequest extends Message<InventoryStockPointSplitRequest> {
  /**
   * Filter by batch ID to get the inventory ledger for a specific batch
   *
   * @generated from field: string batch_id = 1;
   */
  batchId = "";

  /**
   * Type of the item (e.g., MEDICAL, NON_MEDICAL)
   *
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  constructor(data?: PartialMessage<InventoryStockPointSplitRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryStockPointSplitRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "batch_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryStockPointSplitRequest {
    return new InventoryStockPointSplitRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryStockPointSplitRequest {
    return new InventoryStockPointSplitRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryStockPointSplitRequest {
    return new InventoryStockPointSplitRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryStockPointSplitRequest | PlainMessage<InventoryStockPointSplitRequest> | undefined, b: InventoryStockPointSplitRequest | PlainMessage<InventoryStockPointSplitRequest> | undefined): boolean {
    return proto3.util.equals(InventoryStockPointSplitRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.InventoryStockPointSplitResponse
 */
export class InventoryStockPointSplitResponse extends Message<InventoryStockPointSplitResponse> {
  /**
   * List of inventory stock point split items for the specified batch
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryStockPointSplitItem inventory_stock_point_split_items = 1;
   */
  inventoryStockPointSplitItems: InventoryStockPointSplitItem[] = [];

  /**
   * Total number of inventory ledger items for the specified batch
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<InventoryStockPointSplitResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.InventoryStockPointSplitResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "inventory_stock_point_split_items", kind: "message", T: InventoryStockPointSplitItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InventoryStockPointSplitResponse {
    return new InventoryStockPointSplitResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InventoryStockPointSplitResponse {
    return new InventoryStockPointSplitResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InventoryStockPointSplitResponse {
    return new InventoryStockPointSplitResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InventoryStockPointSplitResponse | PlainMessage<InventoryStockPointSplitResponse> | undefined, b: InventoryStockPointSplitResponse | PlainMessage<InventoryStockPointSplitResponse> | undefined): boolean {
    return proto3.util.equals(InventoryStockPointSplitResponse, a, b);
  }
}

